export default __webpack_public_path__ + "static/communication-illus-4c5323a63d1767043933fa404060e4ba.svg";